import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { toast } from 'sonner';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';

export interface PolicyDetailsForm {
  name: string;
  description: string;
  class: Array<string>;
  event: Array<string>;
}

export interface NewPolicy {
  __v: number;
  _id: string;
  class: Array<string>;
  createdAt: string;
  description: string;
  event: Array<string>;
  name: string;
  studio: string;
  updatedAt: string;
}

export const createPolicyAPI = async (policyDetails: PolicyDetailsForm) => {
  const resp = await baseAPI.post<NewPolicy>('/policies', policyDetails);
  return resp.data;
};

export const useCreatePolicyMutation = () => {
  return useMutation({
    mutationFn: async (policyDetails: PolicyDetailsForm) => {
      const response = await createPolicyAPI(policyDetails);
      return response;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['policies'],
      });
    },
    onError: (error: AxiosError<{ message: string }>) => {
      const errorMessage =
        error.response?.data.message ?? 'Failed to create policy';
      toast.error(errorMessage);
    },
  });
};
